declare namespace $ {

	type $rise_devtools_selector_overlay__active_rise_devtools_selector_1 = $mol_type_enforce<
		ReturnType< $rise_devtools_selector['active'] >
		,
		ReturnType< $rise_devtools_selector_overlay['active'] >
	>
	type $rise_devtools_selector_overlay__rect_rise_devtools_selector_2 = $mol_type_enforce<
		ReturnType< $rise_devtools_selector['rect'] >
		,
		ReturnType< $rise_devtools_selector_overlay['rect'] >
	>
	type $rise_devtools_selector_overlay__target_id_rise_devtools_selector_3 = $mol_type_enforce<
		ReturnType< $rise_devtools_selector['target_id'] >
		,
		ReturnType< $rise_devtools_selector_overlay['target_id'] >
	>
	type $rise_devtools_selector_overlay__target_name_rise_devtools_selector_4 = $mol_type_enforce<
		ReturnType< $rise_devtools_selector['target_name'] >
		,
		ReturnType< $rise_devtools_selector_overlay['target_name'] >
	>
	type $rise_devtools_selector_overlay__target_attrs_rise_devtools_selector_5 = $mol_type_enforce<
		ReturnType< $rise_devtools_selector['target_attrs'] >
		,
		ReturnType< $rise_devtools_selector_overlay['target_attrs'] >
	>
	type $rise_devtools_selector_overlay__target_info_rise_devtools_selector_6 = $mol_type_enforce<
		ReturnType< $rise_devtools_selector['target_info'] >
		,
		ReturnType< $rise_devtools_selector_overlay['target_info'] >
	>
	type $rise_devtools_selector_overlay__selected_rise_devtools_selector_7 = $mol_type_enforce<
		ReturnType< $rise_devtools_selector['selected'] >
		,
		ReturnType< $rise_devtools_selector_overlay['selected'] >
	>
	type $rise_devtools_selector_overlay__rpc_port_rise_devtools_selector_8 = $mol_type_enforce<
		ReturnType< $rise_devtools_selector['rpc_port'] >
		,
		ReturnType< $rise_devtools_selector_overlay['rpc_port'] >
	>
	export class $rise_devtools_selector extends $mol_view {
		mousemove_listener( ): $mol_dom_listener | null
		click_listener( ): $mol_dom_listener | null
		keydown_listener( ): $mol_dom_listener | null
		active( next?: boolean ): boolean
		rect( next?: any ): any
		target_id( next?: string ): string
		target_name( next?: string ): string
		target_attrs( next?: readonly(any)[] ): readonly(any)[]
		target_info( ): any
		selected( next?: boolean ): boolean
		rpc_port( ): string
		Overlay( ): $rise_devtools_selector_overlay
		auto( ): readonly(any)[]
		document( ): any
		done( next?: any ): any
		reset( ): any
		target( next?: any ): any
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=selector.view.tree.d.ts.map